import React, { Fragment } from 'react';

// Operator definitions matching UnifiedOperators labels
const greaterOrEq = ['is at least', 'ge', '>='];
const lessOrEq = ['is at most', 'le', '<='];
const greater = ['is greater than', 'gt', '>'];
const less = ['is less than', 'lt', '<'];
const equals = ['equals', 'eq', '='];
const notEquals = ['does not equal', 'ne', '!='];
const on = ['is on', 'eq', '='];
const onBefore = ['is on or before', 'le', '<='];
const before = ['is before', 'lt', '<'];
const onAfter = ['is on or after', 'ge', '>='];
const after = ['is after', 'gt', '>'];
const notOn = ['is not on', 'ne', '!='];
const isEquals = ['equals', 'eq', '='];
const notIsEquals = ['does not equal', 'ne', '!='];
const contains = ['contains text', 'con'];
const notContains = ['does not contain text', 'ncon'];
const scon = ['contains text', 'scon'];
const nscon = ['does not contain text', 'nscon'];
const starts = ['starts with', 'starts'];
const inList = ['is in list', 'in'];
const notInList = ['is not in list', 'nin'];

const intOpValues = [greater, less, greaterOrEq, lessOrEq, equals, notEquals];
const decOpValues = [greater, less, greaterOrEq, lessOrEq, equals, notEquals];
const dtOpValues = [on, before, after, onBefore, onAfter, notOn];
const strOpValues = [isEquals, starts, contains, scon, notIsEquals, notContains, nscon];
const listOpValues = [isEquals, notIsEquals, inList, notInList];

const customOpValues = [
  ...strOpValues,
  ...intOpValues,
  ...dtOpValues,
  ...listOpValues,
];

const opTypeValues = {
  dt: dtOpValues,
  str: strOpValues,
  int: intOpValues,
  dec: decOpValues,
  // eslint-disable-next-line no-useless-computed-key
  ['[str]']: listOpValues,
  obj: customOpValues, // obj type supports all operators
  custom: customOpValues,
};

const includeTitle = 'Include';
const excludeTitle = 'Exclude';

const AudSummary = props => {
  const {
    data: { includes, excludes },
    listBackgroundColor,
  } = props;

  const renderSetSummary = set => {
    return set.rules.map((rule, index) => {
      const { key, kv_relational_op, value, value_type } = rule;
      const op = opTypeValues[value_type].find(arr =>
        arr.includes(kv_relational_op)
      );

      return (
        <div
          className="audience__rules"
          style={{
            display: 'grid',
            gridTemplateColumns: '34% 32% 34%',
            backgroundColor: listBackgroundColor
              ? listBackgroundColor
              : 'rgba(0,0,0,0.1)',
            padding: '0.5rem',
            marginBottom: '0.1rem',
          }}
          key={index}
        >
          <div className="rules__key" style={{ textAlign: 'left' }}>
            {key}
          </div>
          <div className="rules__relation" style={{ textAlign: 'center' }}>
            {(op && op[0]) || kv_relational_op}
          </div>
          <div className="rules__value" style={{ textAlign: 'right' }}>
            {value}
          </div>
        </div>
      );
    });
  };

  const renderSet = (data, title) => {
    return (
      <>
        {data.map((set, index) => {
          return (
            <Fragment key={index}>
              <p
                className="audience__rule-types"
                style={{ textAlign: 'center', padding: '1rem' }}
              >
                {index === 0 && title === excludeTitle && (
                  <strong>ALSO...</strong>
                )}
                {index !== 0 && <strong>AND...</strong>}
                <strong>{title}</strong>&nbsp; at least ONE of the following
              </p>

              {renderSetSummary(set)}
            </Fragment>
          );
        })}
      </>
    );
  };

  return (
    <>
      {includes && renderSet(includes, includeTitle)}
      {excludes && renderSet(excludes, excludeTitle)}
    </>
  );
};

export default AudSummary;
